import type { ApiResponse } from './estClient';

import { estClient } from './estClient';

class TelegramApi {
  async get(): Promise<TelegramConfig> {
    const resp = await estClient.get<TelegramConfigResponse>(
      '/api/telegram/config',
    );

    return resp.telegram_config;
  }

  async save(body: TelegramConfigInput): Promise<TelegramConfig> {
    const resp = await estClient.post<TelegramConfigResponse>(
      '/api/telegram/config',
      {
        bodyFormat: 'url-encoded',
        body,
      },
    );

    return resp.telegram_config;
  }

  async registerWebhook(): Promise<TelegramConfig> {
    const resp = await estClient.post<TelegramConfigResponse>(
      '/api/telegram/webhook_register',
    );

    return resp.telegram_config;
  }

  async getConnectState(): Promise<TelegramConnectState> {
    return estClient.get<TelegramConnectStateResponse>(
      '/api/telegram/connect_url',
    );
  }

  async sendTestMessage(): Promise<void> {
    await estClient.post('/api/telegram/test_message');
  }

  async disconnect(): Promise<void> {
    await estClient.post('/api/telegram/disconnect');
  }
}

export const telegramApi = new TelegramApi();

export interface TelegramConfigInput {
  bot_token: string;
  bot_name: string;
}

export interface TelegramConfig extends TelegramConfigInput {
  is_enabled: boolean;
  webhook_created_at: string;
}

export interface TelegramConnectState {
  /**
   * Personal deep link to the company bot - empty when the bot is not configured
   */
  connect_url: string;

  /**
   * Whether the user has already opened the bot via the link
   */
  is_connected: boolean;
}

export type TelegramConfigResponse = ApiResponse<{
  telegram_config: TelegramConfig;
}>;

type TelegramConnectStateResponse = ApiResponse<TelegramConnectState>;
